import React, { useEffect, useState } from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import RadioField from 'forms/fields/RadioField';
import {PulsingDot} from "components/PulsingDot";
import {TextWithPulsingDot} from "components/TextWithPulsingDot";
import { GreenText } from 'components/GreenText';

const { block, el } = bem('offline-radio-field');
const OfflineRadioField = ({setWorkingOffline, workingOffline, workingOfflineOptions}) => {
    const [disabled, setDisabled] = useState(false);

    const onChange = (e) => {
        const value = e.target.checked;
        setWorkingOffline(e.target.value === 'offline');
        //setFilterValue(e.target.value === 'offline');
    }
    //const setFilterValue = (value) => setFilter('workingOffline', value);

    //const { workingOfflineOptions, setFilter, filters: { workingOffline } } = model;

    useEffect(() => {
        if (workingOfflineOptions.length === 1) {
            //setFilterValue(workingOfflineOptions[0]);
            setWorkingOffline(workingOfflineOptions[0])
        }
        setDisabled(workingOfflineOptions.length === 1 && workingOfflineOptions[0] === false);
    }, [workingOfflineOptions])

    return (
        <div className={block({disabled})}>
            <div className={ el( 'radio-option', {'selected': workingOffline === false } ) }>
                <RadioField
                    name={'offline'}
                    text={ <TextWithPulsingDot><GreenText>Онлайн</GreenText>-встреча</TextWithPulsingDot> }
                    value={'online'}
                    checked={workingOffline === false}
                    onChange={onChange}
                />
            </div>
            <div className={ el( 'radio-option', {'selected': workingOffline === true } ) }>
                <RadioField
                    name={'offline'}
                    text={ 'Очная встреча' }
                    value={'offline'}
                    checked={workingOffline === true}
                    onChange={onChange}
                />
            </div>
        </div>
    )
}

export default observer(OfflineRadioField);
